// extracted by mini-css-extract-plugin
export default {"container":"items_container__VN8m9","title":"items_title__E41b5"};